const zh_CN = {
    "CreateBusinessDocs": "业务开单",
    "MaintenanceAppointment": "维修预约",
    "Customer": "客户名称",
    "Contact": "联系人",
    "Document Status": "单据状态",
    "Registered": "已登记",
    "Cancelled": "已作废",
    "Transferred": "已转接",
    "AppointmentDocNo": "单据编号",
    "ServiceType": "维修类型",
    "Repair": "维修",
    "SheetMetal": "钣金",
    "SprayPaint": "喷漆",
    "PDI": "PDI",
    "VIN": "VIN码",
    "CreationStartTime": "制单开始",
    "CreationEndTime": "制单结束",
    "Search": "检索",
    "Reset": "重置",
    "SN": "序号",
    "Appointment Doc No.": "预约单号",
    "Creation Time": "单据日期",
    "Contact": "联系人",
    "Contact Number": "联系电话",
    "Estimated Man-hours": "预计工时",
    "Estimated Labor Cost": "预计工时费",
    "Estimated Material Cost": "预计材料费",
    "Total Amount": "费用合计",
    "Appointed Enter Time": "预约进厂",
    "Appointed Delivery Time": "预约出厂",
    "Creator": "制单员",
    "Appointed Technicians": "预约技师",
    "Cancel Reason": "失约原因",
    "Print Times": "打印次数",
    "Note": "备注",
    "Page Up": "上一页",
    "Page Down": "下一页",
    "Add": "新增",
    "Edit": "编辑",
    "View": "查看",
    "Cancel": "作废",
    "Transfer to Maintenance": "转维修",
    "Print": "打印",
    "New Appointment Doc": "预约单新增",
    "Appointment Doc": "预约单",
    "Status": "状态",
    "Save": "保存",
    "Back": "返回",
    "Basic Info": "基本信息",
    "Address": "客户地址",
    "License Plate": "车辆牌照",
    "Vehicle Model": "车辆型号",
    "Service Nature": "服务性质",
    "Three Guarantees": "三包",
    "Charge": "收费",
    "Technician": "维修技师",
    "Service Location": "服务地点",
    "In Station": "站内",
    "On Scene": "站外",
    "Payment Type": "结算类型",
    "On Credit": "记账",
    "Cash": "现金",
    "Cheque": "支票",
    "Creation Time": "制单时间",
    "Faults": "故障描述",
    "Cancel Reason": "失约原因",
    "Maintenance Schedule": "维修方案",
    "Note": "备注",
    "Maintenance Item": "维修项目",
    "Maintenance Material": "维修用料",
    "Add Item": "新增项目",
    "Delete Item": "删除项目",
    "Add Material": "新增用料",
    "Delete Material": "删除用料",
    "SN": "序号",
    "Item Code": "项目编码",
    "Item": "项目名称",
    "Service Nature": "服务性质",
    "Claim Unit": "三包单位",
    "Service Type": "维修类型",
    "Man-hours": "工时数",
    "Unit Price": "工时单价",
    "Labor Cost": "工时费",
    "Discount Rate": "折扣",
    "Note": "备注",
    "Man-hours": "工时数",
    "Labor Cost": "工时费",
    "Material Cost": "零件费",
    "Total Amount": "费用合计",
    "Save": "保存",
    "Back": "返回",
    "Cancel Reason": "请填写作废原因",
    "Material Code": "商品编码",
    "Material Name": "商品名称",
    "Manufacturer Code": "替换号",
    "Service Nature": "服务性质",
    "Claim Unit": "三包单位",
    "Inventory": "库存",
    "Unit": "单位",
    "Qty": "数量",
    "Unit Price": "单价",
    "Amount": "金额",
    "Discount Rate": "折扣",
    "Total": "总计",
    "Warehouse": "仓库",
    "Shelf": "货位",
    "Select Maintenance Item": "选择维修项目",
    "Search": "检索",
    "Reset": "重置",
    "Material Code": "商品编码",
    "Material Name": "商品名称",
    "Manufacturer Codes": "原厂编号",
    "Production Place": "产地",
    "Spec": "规格",
    "Inventory": "库存",
    "Unit": "单位",
    "Qty": "数量",
    "Unit Price": "单价",
    "Amount": "金额",
    "Warehouse": "仓库",
    "Shelf": "货位",
    "Operation": "操作",
    "Marketing Warehouse": "投放库",
    "Purchase, Sales and Inventory Details": "商品进销存明细",
    "Purchase History": "采购历史",
    "Sales History": "销售历史",
    "Document  Type": "单据类型",
    "Refresh": "刷新",
    "This item is Required": "该项为必填项",
    "Vehicle type": "车辆类型",
    "More": "更多>>",
    "Hide": "隐藏",
    "Delete": "删除",
    "Accessories brand": "配件品牌",
    "Preferential amount": "优惠金额",
    "taxation": "税费",
    "Not yet": "暂无",
    "Maintenance": "维修开单",
    "Maintenance Doc No.": "工单单号",
    "Ex-warehoused": "已出库",
    "Settled": "已结算",
    "Labor Cost": "工时费",
    "Material Cost": "材料费",
    "Discount Amount": "优惠金额",
    "Enter Time": "进厂时间",
    "Delivery Time": "出厂时间",
    "Stock-out Time": "出库时间",
    "Settle Time": "结算时间",
    "Creator": "制单员",
    "Technician": "维修技师",
    "Settle": "结算",
    "Stock out": "出库",
    "Favorable Amount": "去零",
    "turn": "转",
    "Settle": "结算",
    "Storekeeper": "库管员",
    "Reckoner": "结算员",
    // 销售订单
    "Sales Order": "销售订单",
    "Order Number": "订单数量",
    "Order Amount":"订单总金额",
    "Sales Order No.":"销售订单号",
    "Transfer Sales":"转销售单",
    "Sales order transfer sales doc.":"销售订单转销售单",
    "Transfer sales doc. successful" : "转接销售单成功",
    // 配件销售员
    "Material Sales": "配件销售",
    "SN": "序号",
    "Sales Doc No.": "销售单号",
    "Status": "单据状态",
    "Creation Time": "单据日期",
    "Customer": "客户名称",
    "Contact": "联系人",
    "Contact Number": "联系电话",
    "Sales Amount": "销售金额",
    "Discount Amount": "优惠金额",
    "Receivable Amount": "应收金额",
    "Payment Type": "结算类型",
    "Creator": "制单员",
    "Storekeeper": "库管员",
    "Stock-out Time": "出库时间",
    "Reckoner": "结算员",
    "Settle Time": "结算时间",
    "Add Sales Doc": "销售单新增",
    "Sales Doc No.": "销售单号",
    "Status": "状态",
    "Address": "客户地址",
    "Payment Type": "	结算类型",
    "Creation Time": "制单时间",
    "zero-suppression": "去零",
    "Customer Type": "客户类型",
    "Personal Customer": "个人客户",
    "manufacturer Customer": "厂家客户",
    "Group Customer": "集团客户",
    "Major Customer": "大客户",
    "Note": "备注",
    "Sales Details": "销售明细",
    "Import Details": "导入明细",
    "Download template": "下载模板",
    "Sales Qty": "销售数量",
    "Sales Amount": "销售金额",
    "Discount Amount": "优惠金额",
    "Material Code": "商品编码",
    "Material Name": "商品名称",
    "Qty": "数量",
    "Unit Price": "单价",
    "Discount Rate": "折扣",
    "Warehouse": "仓库",
    "Shelf": "货位",
    "Inventory": "库存",
    "Select Material": "选择配件",
    "Marketing Warehouse": "投放库",
    //销售退货
    "Sales Return": "销售退货",
    "Sales Return Doc No.": "退货单号",
    "Return Amount": "退货金额",
    "Payment Type": "结算类型",
    "Return Reason": "退货原因",
    "Creator": "制单员",
    "Storekeeper": "库管员",
    "Stock-in Time": "入库时间",
    "Reckoner": "结算员",
    "Settle Time": "结算时间",
    "Print Times": "打印次数",
    "Sales Return Docs": "销售退货单",
    "Return Details": "销退明细",
    "Return Qty": "退货数量",
    "Return Item Number": "退货项数",
    "Return Amount": "退款金额",
    "Stock in": "入库",
    "Sales unit price": "销售单价",
    "Return unit price": "退货单价",
    "Sales discount": "销售折扣",
    "Returned quantity": "已退数量",
    //采购入库
    "Purchase Management": "采购管理",
    "Purchase & Stock In": "采购入库",
    "Supplier Name": "供应商名称",
    "SN": "序号",
    "Purchase Doc No.": "采购单号",
    "Purchase Qty": "采购数量",
    "Purchase Amount": "采购金额",
    "Creator": "制单员",
    "Storekeeper": "库管员",
    "Stock-in Time": "入库时间",
    "Reckoner": "结算员",
    "Settle Time": "结算时间",
    "Purchase Doc": "采购单",
    "Purchase Doc No.": "采购单号",
    "Stock in": "入库",
    "Supplier Type": "供应商类型",
    "Purchase Details": "采购明细",
    "Download Template": "下载模板",
    "Material Brand": "商品品牌",
    "Purchase Qty": "采购数量",
    "Unit Price": "采购单价",
    "Purchase Amount": "采购金额",
    "Purchase Item Number": "采购项数",
    //采购退货
    "Purchase Return": "采购退货",
    "Purchase Return Doc No.": "采购退货单号",
    "Purchase Return Doc": "采购退货单",
    "Return Qty": "退货数量",
    "Return Amount": "退货金额",
    "Add Purchase Return Doc": "采购退货单新增",
    "Supplier Type": "供应商类型",
    "Return Qty": "退货数量",
    "Unit Price": "退货单价",
    "Return Amount": "退款金额",
    "Return Item Number": "退货项数",
    "Mining and return details": "采退明细",
    // 库存统计
    "Warehouse Management": "仓库管理",
    "Inventory Statistics": "库存统计",
    "Warehouse Managements": "所属库房",
    "Shelf": "所属货位",
    "Only show available": "只显示有货",
    "Material Type": "商品分类",
    "Material Brand": "商品品牌",
    "Spec&Model": "规格型号",
    "Qty in Stock": "库存数量",
    "Latest Purchase Price": "进货价（最近）",
    "Latest Retail Price": "零售价（最近）",
    "Latest Inventory Cost": "库存成本（最近）",
    "Shortage Qty": "短缺数量",
    "Redundant Qty": "超存数量",
    "Average Purchase Price": "进货价（平均）",
    "Average Inventory Cost": "库存成本（平均）",
    "Qty in Stock": "库存总量",
    "Species Number in Stock": "库存种类",
    "Upper Limit": "库存上限",
    "Lower Limit": "库存下限",
    "Outbound order": "出库单",
    "Stock in order": "入库单",
    "Statistics Details": "统计明细",
    "Stock-io Type": "出入类型",
    "Document  Type": "单据类型",
    "Document No.": "单据编号",
    "Qty": "数量",
    "Unit Price": "单价",
    "Amount": "金额",
    //库存盘点
    "Stocktaking": "库存盘点",
    "Stocktaking Doc No.": "盘点单号",
    "Stocktaking status": "盘点状态",
    "Result": "盘点结果",
    "Stocktaking Surplus Doc": "盘盈单据",
    "Stocktaking Loss Doc": "盘亏单据",
    "SN": "序号",
    "Stocktaking Time": "盘点时间",
    "underway": "进行中",
    "Finished": "已完成",
    "Cancelled": "已作废",
    "Document  Type": "单据类型",
    "Stocktaking  Type": "盘点类型",
    "initialization Doc": "期初单",
    "Stocktaking Doc No.": "盘点单号",
    "System Inventory": "系统库存",
    "Stocktaking Inventory": "盘点库存",
    "Stocktaking Surplus Qty": "盘盈总数",
    "Stocktaking Loss Qty": "盘亏总数",
    "Result": "盘点结果",
    "Creator": "制单人",
    "Note": "备注",
    "Add  Stocktaking Doc": "库存盘点新增",
    "Stocktaking Doc No.": "盘点单号",
    "Finish": "盘点完成",
    "Start Time": "开始时间",
    "End Time": "结束时间",
    "Stocktaking Details": "盘点明细",
    "Difference Qty": "差异量",
    "Difference Amount": "差异金额",
    "System Inventory": "系统库存",
    "Real Inventory": "实际库存",
    "Surplus Item Number": "盘盈项数",
    "Loss Item Number": "盘亏项数",
    "Difference Qty": "差异数量",
    "Difference Amount": "差异金额",
    "Difference Rate": "差异率",
    "Stocktaking Doc": "盘点单",
    "Stocktaking Num": "盘点数量",
    //出库单据
    "Stock Out": "出库单据",
    "Stock-out Doc No.": "出库单号",
    "Document  Type": "单据类型",
    "Material Code": "配件编码",
    "Stock-out Qty": "出库数量",
    "Stock-out Time": "出库时间",
    "Creator": "制单员",
    "Creation Time": "制单时间",
    "Stock-out Doc Number": "出库单数",
    //入库单据
    "Stock In": "入库单据",
    "Stock In Doc No.": "入库单号",
    "Stock-in Qty": "入库数量",
    "Stock-in Doc Number": "入库单数",
    "Stock-in Time": "入库时间",
    //供应商档案
    "Basic Data": "基础数据",
    "Supplier Management": "供应商管理",
    "Supplier Code": "供应商编码",
    "Supplier Name": "供应商名称",
    "Supplier Type": "供应商类型",
    "Supplier": "供应商",
    "Supplier Details": "供应商详情",
    "Basic Info": "基础信息",
    "Contact": "联系人",
    "Contact Number": "联系电话",
    "Email": "电子邮箱",
    "Office Tel": "办公电话",
    "Address": "联系地址",
    "Postcode": "邮编",
    "Note": "备注",
    "open": "开启",
    "close": "关闭",
    "Import": "导入",
    "Record Time": "登记时间",
    "Billing information": "开票信息",
    "Invoice title": "发票抬头",
    "Business license": "营业执照",
    "Invoice Info": "开票信息",
    "Invoice Title": "发票抬头",
    "Business License": "营业执照",
    "Bank": "开户银行",
    "Bank Account": "银行账户",
    "Mailing Address": "邮寄地址",
    "Legal Person": "公司法人",
    "Other Info": "其他信息",
    "Founder": "创建人",
    "Founder Time": "创建时间",
    "Updater": "修改人",
    "Update Time": "修改时间",
    //配件管理
    "Material Management": "配件档案",
    "Replace Code": "替换编号",
    "Material Status": "商品状态",
    "Material Code": "商品编号",
    "Production Place": "产地",
    "Upper Limit": "库存上限",
    "Lower Limit": "库存下限",
    "Purchase Price": "进货价",
    "Retail Price": "零售价",
    "Warehouse": "所属仓库",
    "Shelf": "所属货位",
    "Inventory information": "库存信息",
    "Material Price": "商品价格",
    "Material Details": "配件档案详情",
    //仓库管理
    "Warehouse Settings": "仓库设置",
    "Warehouse Code": "仓库编码",
    "Warehouse Name": "仓库名称",
    "Warehouse Type": "仓库类别",
    "Shelf Code": "货位编码",
    "Warehouse": "所属仓库",
    "Prefix": "前缀",
    "Start Code": "起始编码",
    "New Warehouse": "仓库新增",
    "New Shelf": "货位新增",
    "Total Qty of Warehouse Shelf": "仓库货位 总数",
    "Warehouse Details": "仓库详情",
    "Shelf Information": "货位信息",
    "Batch entry": "批量录入",
    //客户管理
    "Customer Management": "客户档案",
    "Subordinate Vehicle": "下属车辆",
    "Customer": "客户名称",
    "Customer Type": "客户类型",
    "Address": "客户地址",
    "Operation": "操作",
    "Enable": "启用",
    "Disable": "禁用",
    "Add Customer": "客户新增",
    "Edit Customer": "客户编辑",
    "Customer Details": "客户详情",
    "Reset": "重置",
    "Customer Code": "客户编码",
    "Email": "电子邮箱",
    "Office Tel": "办公电话",
    "Record Time": "登记时间",
    "Postcode": "邮编",
    "Note": "备注",
    "Customer Status": "客户状态",
    "Invoice Info": "开票信息",
    "Invoice Title": "发票抬头",
    "Business License": "营业执照",
    "Bank": "开户银行",
    "Bank Account": "银行账户",
    "Legal Person": "公司法人",
    "Business Scope": "经营范围",
    "Other Info": "其他信息",
    "Updater": "修改人",
    "Update Time": "修改时间",
    //车辆信息
    "Vehicle Management": "车辆档案",
    "License Plate": "车辆牌照",
    "Vehicle Type": "车辆类型",
    "VIN": "VIN码",
    "Engine No.": "发动机号",
    "Vehicle Code": "车辆编码",
    "Vehicle Model": "车辆型号",
    "Delivery Time": "车辆出厂时间",
    "Record Time": "登记时间",
    "Using Property": "使用性质",
    "Vehicle Status": "车辆状态",
    "Back to Customer": "返回客户",
    "Add Vehicle": "车辆新增",
    "Edit Vehicle": "车辆编辑",
    "Vehicle Details": "车辆详情",
    // 维修项目
    "Maintenance Items": "维修项目档案",
    "Item Code": "项目编码",
    "Item": "项目名称",
    "Man-hours": "工时",
    "Unit Price": "单价",
    "Labor Cost": "工时费",
    "New Maintenance Item": "维修项目新增",
    "Edit Maintenance Item": "维修项目编辑",
    "Item Details": "维修项目详情",
    "Basic Info": "基本信息",
    "Service Type": "维修类型",
    "Repair": "维修",
    "Sheet Metal": "钣金",
    "Spray Paint": "喷漆",
    "PDI": "PDI",
    //维修技师
    "Technician Management": "维修技师档案",
    "New Technician": "维修技师新增",
    "Edit Technician": "维修技师",
    "Name": "姓名",
    "Phone": "手机号",
    "Post": "职位",
    "Assigned Points": "分配点数",
    //角色设置
    "System Settings": "系统设置",
    "Character Settings": "角色设置",
    "Character Name": "角色名称",
    "Character Code": "角色编码",
    "Character Description": "角色描述",
    "Note": "备注",
    //员工设置
    "Employee Settings": "员工设置",
    "Employee": "员工姓名",
    "Contact Number": "联系电话",
    "Employee Account": "员工账号",
    "Account Password": "账号密码",
    "Address": "联系地址",
    "Email": "联系邮箱",
    "Post": "所属岗位",
    "System Role": "系统角色",
    "Creator": "开单员",
    "Storekeeper": "库管员",
    "Reckoner": "结算员",
    "Technician": "维修技师",
    "Person in Charge": "负责人",
    "Add Employee": "员工新增",
    "Edit Employee": "员工编辑",
    "View Employee": "员工查看",
    //数据字典
    "Add subordinates": "增加下级",
    "Add sibling": "增加同级",
    "cancel": "取消",
    "Local Save": "本地保存",
    "Data dictionary": "数据字典",
    "PCode": "父级编码",
    "Code": "编码",
    "NamesEn": "英文名称",
    "Names": "名称",
    "Select the parent field you want to add.": "请选择要增加的父级",
    "Enable mode of adding subordinate field.": "增加下级模式开启",
    "Select the brother field you want to add.": "请选择要增加的同级",
    "Enable mode of adding brother field.": "增加同级模式开启",
    "Please select the node to delete.": "请选择要删除的节点",
    "Business Process Diagram": "业务流程图",
    "Functional distribution diagram":"功能分布图",
    //通用message提示字段
    "Please select a single piece of data for editing.": "请选择单条数据进行编辑",
    "The document is invalid and cannot be edited.": "该单据已作废，无法进行编辑",
    "Jump to the detail page of maintenance doc.": "维修单跳转详情",
    "The detail page of maintenance doc has not been saved. Do you still want to jump?": "您还有维修单详情未保存，是否跳转",
    "Jump to the unsaved page": "跳转未保存页",
    "Open a new page": "打开新页签",
    "Please select a single piece of data to view.": "请选择单条数据进行查看",
    "Please select a single piece of data for cancellation.": "请选择单条数据进行作废",
    "Successfully transferred to maintenance doc": "转维修单成功",
    "Unsuccessfully transferred to maintenance doc": "转维修单失败",
    "Successfully added": "新增成功",
    "Successfully edited": "编辑成功",
    "Successfully refreshed": "刷新成功",
    "Selected  Qty ≥ Stock Qty": "选择数量≥库存数量",
    "Maintenance Appointment - Select Items": "维修预约-选择项目",
    "List of items to be selected": "待选项目列表",
    "List of selected items": "已选项目列表",
    "Material Brand": "配件品牌",
    "List of materials to be selected": "待选配件列表",
    "List of selected materials": "已选配件列表",
    "Maintenance Appointment - Select Materials": "维修预约-选择用料",
    "Discount Amount": "优惠金额",
    "Taxes": "税费",
    "Successfully settled": "结算成功",
    "Unsuccessfully settled": "结算失败",
    "Successfully stocked out": "出库成功",
    "Unsuccessfully stocked out": "出库失败",
    "The maintenance doc": "该维修单",
    "cannot be edited again.": "无法在进行编辑操作",
    "Successfully deleted": "删除成功",
    "Unsuccessfully deleted": "删除失败",
    "The item name of": "项目名称：",
    "is repeated and will not be added.": "，重复的将不在添加。",
    "The material name of": "物料名称：",
    "The customer does not have a vehicle. Click the license plate field on the left to add a new one.": "该客户下没有车辆，点击左侧车辆牌照去新增吧",
    "The document has been settled and cannot be edited.": "该单据已结算，无法进行编辑",
    "The document has been stocked out and cannot be edited.": "该单据已出库，无法进行编辑",
    "The document has been cancelled and cannot be edited.": "该单据已作废，无法进行编辑",
    "Cancel the maintenance doc.": "维修单作废",
    "Settle the maintenance doc.": "维修单结算",
    "Stock out the maintenance doc.": "维修单出库",
    "Stock in the maintenance doc.": "维修单入库",
    "The current number is invalid.": "当前不是一个有效数字",
    "Sales Qty ≥ Inventory Qty": "销售数量≥库存数量",
    "Sales Doc -Select Materials": "销售单-选择配件",
    "Jump to the detail page of sales return doc.": "销售退货单跳转详情",
    "The detail page of sales return doc has not been saved. Do you still want to jump?": "您还有销售退货单详情未保存，是否跳转",
    "Cancel the sales return doc.": "销售退货单作废",
    "Stock in the sales return doc.": "销售退货单入库",
    "Settle the sales return doc.": "销售退货单结算",
    "Sales Unit Price": "销售单价",
    "Return Unit Price": "退货单价",
    "Sales Return Qty ≥ Sales Qty - Returned Qty, return qty should be less than": "销售退货数量≥销售数量-已退数量 ,退货数量应小于",
    "Sales Return Qty ≥ Sales Qty - Returned Qty": "销售退货数量≥销售数量-已退数量",
    "Sales Discount": "销售折扣",
    "Sales Return Doc -Select Materials": "销售退货单-选择配件",
    "Purchase Doc -Select Materials": "采购单-选择配件",
    "Purchase Return Doc -Select Materials": "采购退货单-选择配件",
    "Purchase Return Details": "采退明细",
    "Return Qty ≥ Purchase Qty + Returned Qty": "退货数量≥采购数量+已退数量",
    "Type of Stock-io": "出入类型",
    "Document No.": "单据编号",
    "Surplus": "盘盈",
    "Loss": "盘亏",
    "Equal": "相符",
    "The document has been completed and cannot be operated again.": "单据已完成，无法再次盘点",
    "Stocktaking failed.": "盘点失败",
    "Stocktaking succeeded.": "盘点成功",
    "Average Purchase Price": "平均进货价",
    "Lastest Sales Price": "最近销售价",
    "Qty Difference Rate": "数量差异率",
    "Amount Difference Rate": "金额差异率",
    "The supplier is added successfully.": "供应商新增成功",
    "The supplier is added unsuccessfully.": "供应商新增失败",
    "The supplier is edited successfully.": "供应商编辑成功",
    "The supplier is edited unsuccessfully.": "供应商编辑失败",
    "Successfully imported": "导入成功",
    "Unsuccessfully imported": "导入失败",
    "Inventory Information": "库存信息",
    "Please enter a numeric type. Two decimal digits can be reserved.": "请输入数值类型,可保留二位位小数",
    "title": "标题",
    "Yes No": "确定",
    "Please enter your reason for cancellation": "请输入作废原因",
    "Select Materials": "选择用料",
    "Select Items": "选择项目",
    "Jump to the detail page of Sales doc.": "销售单跳转详情",
    "The detail page of Sales doc has not been saved. Do you still want to jump?": "您还有销售单详情未保存，是否跳转",
    "Cancel the Sales doc.": "销售单作废",
    "Settle the Sales doc.": "销售单结算",
    "Stock out the Sales doc.": "销售单出库",
    "Please add material details.": "请新增商品明细",
    "Successfully stocked in": "入库成功",
    "Unsuccessfully stocked in": "入库失败",
    "The document has been stocked in and cannot be edited.": "该单据已入库，无法进行编辑",
    "Jump to the detail page of Purchase doc.": "采购单跳转详情",
    "The detail page of Purchase doc has not been saved. Do you still want to jump?": "您还有采购单详情未保存，是否跳转",
    "Cancel the Purchase doc.": "采购单作废",
    "Settle the Purchase doc.": "采购单结算",
    "Stock in the Purchase doc.": "采购单入库",
    "Jump to the detail page of Purchase Return doc.": "采购退货单跳转详情",
    "The detail page of Purchase Return doc has not been saved. Do you still want to jump?": "您还有采购退货单详情未保存，是否跳转",
    "Cancel the Purchase Return doc.": "采购退货单作废",
    "Settle the Purchase Return doc.": "采购退货单结算",
    "Stock out the Purchase Return doc.": "采购退货单出库",
    "There is no data in the purchase return detail, please add it quickly.": "采退明细里还没有数据，快去添加吧",
    "Jump to the detail page of stocktaking doc.": "库存盘点跳转详情",
    "The detail page of stocktaking doc has not been saved. Do you still want to jump?": "您还有库存盘点单详情未保存，是否跳转",
    "Cancel the stocktaking doc.": "盘库单作废",
    "Unsuccessfully edited": "编辑失败",
    "Unsuccessfully added": "新增失败",
    "Successfully added": "新增成功",
    "Successfully edited": "编辑成功",
    "Successfully refreshed": "刷新成功",
    "Jump to the detail page": "跳转详情",
    "The detail page has not been saved. Do you still want to jump?": "您还有详情未保存，是否跳转",
    "New shelf has been successfully added.": "货位新增成功",
    "New shelf has been unsuccessfully added.": "货位新增失败",
    "New data dic has been successfully added.": "字典增加成功",
    "New data dic has been successfully edited.": "字典编辑成功",
    "New data dic has been successfully deleted.": "字典删除成功",
    "The code is required.": "编码为必填项",
    "ItemEn": "项目名称-英文",
    "Material Name En": "商品名称-英文",
    "day": "日",
    "month": "月",
    "week": "周",
    "Quotation Print":"报价单打印",
    "SaleBill Print":"销售清单打印",
    "Discounted Price":"折后单价",
    "export":"导出",
    "Details export":"详情导出",
    "List export":"列表导出",
    "Statistic Analysis": "统计分析",
    "Stock-io  List": "出入汇总表",
    "Stock-io Type": "出入类型",
    "Stock out": "出库",
    "Stock in": "入库",
    "Document  Type": "单据类型",
    "Sales Docs": "销售单",
    "Maintenance Docs": "维修单",
    "Sales Return Docs": "销售退货单",
    "Purchase Docs": "采购单",
    "Purchase Return Docs": "采购退货单",
    "Stock-io Time": "出入库时间",
    "Material Code": "商品编码",
    "Material Name": "商品名称",
    "Qty": "数量",
    "Unit Price": "单价",
    "Amount": "金额",
    "Payment Method": "结算方式",
    "Creator": "开单员",
    "Storekeeper": "库管员",
    "Reckoner": "结算员",
    "Stock-out Qty": "出库数量",
    "Stock-out Amount": "出库金额",
    "Stock-in Qty": "入库数量",
    "Stock-in Amount": "入库金额",
    "Technician Performance": "技师业绩",
    "SN": "序号",
    "Technician": "维修人员",
    "Maintenance Vehicle- times": "维修台次",
    "Total Man-hours": "总工时数",
    "Labor Cost": "工时费",
    "Percentage": "提成",
    "Maintenance Man-hours": "维修工时",
    "Total　Labor Cost": "工时费合计",
    "Receivable Amount": "应收统计",
    "Document No.": "单据编号",
    "Document  Type": "单据类型",
    "Customer": "客户名称",
    "Customer Attribute": "客户属性",
    "Customer": "客户",
    "Supplier": "供应商",
    "Receivable Amounts": "应收金额",
    "Creator": "制单人",
    "Creation Time": "制单时间",
    "Total Payable Amount": "应付统计",
    "Payable Amount": "应付金额",
    "Paid Amount":"已付金额",
    "Turnover": "营业额",
    "Receivable Amount": "应收金额",
    "Received Amount": "已收金额",
    "Creation Time": "单据时间",
    "Sales Volume": "销售额",
    "Maintenance Volume": "维修额",
    "Creation Time": "单据时间",
    "Labor Cost": "工时费",
    "Material Cost": "零件费",
    "Total Labor Cost": "工时费合计",
    "Total Material Cost": "零件费合计",
    "Total Receivable Amount": "应收合计",
    "Total Received Amount": "已收合计",
    "Total amount":"总计金额",
    "Purchase Return Qty":"采退数量",
    "Payment status":"支付状态",
    "Write off time":"核销时间",
    "Chargeback": "维修退单",
    "Chargeback Doc No.": "退单单号",
    "Maintenance status": "维修状态",
    // "Chargeback":"退单",
    "Chargeback approval":"退单审核",
    "Original man hour":"原单工时",
    "Original order quantity":"原单数量",
    "The document is not in the maintenance return state of approving, so it cannot be approve.":"该订单不是退单审核状态，无法进行审核",
    "The document has been in the maintenance return state of approving and cannot be repeated.":"该订单已是退单审核状态，不可重复操作",
    "The document is not Stock out and is not in the maintenance return state of pending-approving, so it cannot be edited.":"该单据不是已出库，退单审核初始状态，无法进行编辑"
}
export default zh_CN